import React, { Component } from 'react';
import { connect } from 'react-redux';
import WeeklyProgramCalendar from '../weeklyPrograms/calendar';
import utils from '../../common/services/utils';
import { loadWeeklyProgram } from './actions';
import { initialize } from 'redux-form';

class KindergartenProgram extends Component {

	constructor(props) {
		super(props);
		this.handleSelectWeeklyProgram = this.handleSelectWeeklyProgram.bind(this);
		this.initializeFilter = this.initializeFilter.bind(this);
	}

	initializeFilter(form, data, fields) {
		return this.props.initialize(form, data, fields);
	}

	handleSelectWeeklyProgram(day, weeklyProgramItem) {
		const { history } = this.props;
		history.push(`/kindergartenAttendance/manage?weeklyProgramItemId=${weeklyProgramItem.id}`);
	}

	render() {
		const {
			terms, centers, weeklyPrograms, t, currentUser,
			loadWeeklyProgram, weeklyProgramFilter,
			timetableViewType
		} = this.props;

		return (
			<WeeklyProgramCalendar
				kindergarten={true}
				onWeeklyProgramItemClick={this.handleSelectWeeklyProgram}
				weeklyPrograms={weeklyPrograms}
				currentUser={currentUser}
				centers={centers}
				terms={terms}
				loadWeeklyProgram={loadWeeklyProgram}
				weeklyProgramFilter={weeklyProgramFilter}
				initializeFilter={this.initializeFilter}
				timetableViewType={timetableViewType}
			/>
		);
	}
}

const mapStateToProps = state => {
	const {
		entities: { terms, centers, weeklyPrograms },
		auth: { currentUser },
		configuration: { franchisor },
		filters
	} = state;

	const kindergartenAttendanceWeeklyProgramFilter = filters.kindergartenAttendanceWeeklyProgram.all || { ids: [], filter: {}, loading: false };
	const onlineCenters = utils.filter(centers, center => center.isOnline && center.territory && center.territory.isOnline);
	const activeWeeklyPrograms = utils.filter(weeklyPrograms, p => !p.isDeleted && !p.isClosed);

	return {
		centers: onlineCenters,
		terms: terms,
		weeklyPrograms: activeWeeklyPrograms,
		currentUser,
		timetableViewType: franchisor.timetableViewType,
		weeklyProgramFilter: kindergartenAttendanceWeeklyProgramFilter
	};
};

const mapDispatchToProps = {
	loadWeeklyProgram,
	initialize
}

export default connect(mapStateToProps, mapDispatchToProps)(KindergartenProgram);